import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Container } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import Components from '../components'
import DashboardNavigation from '../components/partials/DashboardNavigation'
import DashboardContainer from '../components/partials/DashboardContainer'

import ws from '../ws'

const HOME_NAME = 'VPPGamingNetwork'
const SUB_NAME = 'Dashboard'

const routeList = [
  {
    path: '/dashboard',
    to: '/dashboard/news',
    exact: true,
    type: 'redirect'
  },
  {
    title: 'News',
    path: '/dashboard/news',
    component: Components.News.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/news', title: 'News' }
    ]
  },
  {
    title: 'News',
    path: '/dashboard/news/new',
    component: Components.News.Create,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/news', title: 'News' },
      { url: '/dashboard/news/new', title: 'Edit Post' }
    ]
  },
  {
    title: 'News',
    path: '/dashboard/news/:seo',
    component: Components.News.Single,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/news', title: 'News' }
    ]
  },
  {
    title: 'News',
    path: '/dashboard/news/:seo/edit',
    component: Components.News.Edit,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/news', title: 'News' }
    ]
  },
  {
    title: 'Transactions',
    path: '/dashboard/transactions',
    component: Components.Transactions,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/transactions', title: 'Transactions' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/user/groups',
    component: Components.User.Group.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/user', title: 'User' },
      { url: '/dashboard/user/groups', title: 'Groups' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/user/groups/new',
    component: Components.User.Group.Create,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/user', title: 'User' },
      { url: '/dashboard/user/groups', title: 'Grouos' },
      { url: '/dashboard/user/groups/new', title: 'Create' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/user/groups/:groupId',
    component: Components.User.Group.Edit,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/user', title: 'User' },
      { url: '/dashboard/user/groups', title: 'Groups' },
      { url: '/dashboard/user/groups/:groupId', title: 'Edit' }
    ]
  },
  {
    title: 'User',
    path: '/dashboard/user',
    component: Components.User.User.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/user', title: 'User' }
    ]
  },
  {
    title: 'User',
    path: '/dashboard/user/:userId',
    component: Components.User.User.Edit,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/user', title: 'User' },
      { url: '/dashboard/user/:userId', title: 'Edit' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/billings',
    component: Components.Community.Main.Billings,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/billings', title: 'Billings' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/applications',
    component: Components.Community.Main.Application,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/applications', title: 'Applications' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community',
    component: Components.Community.Main.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/new',
    component: Components.Community.Main.Create,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/new', title: 'Create' }
    ]
  },
  {
    path: '/dashboard/community/:comId',
    to: '/dashboard/community/:comId/application',
    type: `redirect`,
    exact: true
  },
  {
    title: 'Community',
    path: '/dashboard/community/:comId/application',
    component: Components.Community.Application.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/application', title: 'Application' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/:comId/billing',
    component: Components.Community.Billing.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/billing', title: 'Billing' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/:comId/revenue',
    component: Components.Community.Revenue.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/revenue', title: 'Revenue' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/:comId/users',
    component: Components.Community.User.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/users', title: 'Users' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/:comId/users/:userId',
    component: Components.Community.User.Edit,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/users', title: 'Users' },
      { url: '/dashboard/community/users/:userId', title: 'Edit User' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/:comId/groups',
    component: Components.Community.Group.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/groups', title: 'Groups' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/:comId/groups/new',
    component: Components.Community.Group.Create,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/groups', title: 'Groups' },
      { url: '/dashboard/community/groups/new', title: 'Create' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/:comId/groups/:groupId',
    component: Components.Community.Group.Edit,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/groups', title: 'Groups' },
      { url: '/dashboard/community/groups/:groupId', title: 'Edit' }
    ]
  },
  {
    title: 'Community',
    path: '/dashboard/community/:comId/settings',
    component: Components.Community.Settings.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/community', title: 'Community' },
      { url: '/dashboard/community/settings', title: 'Settings' }
    ]
  },
  {
    title: 'Statistics',
    path: '/dashboard/statistics',
    component: Components.Statistics.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/statistics', title: 'Statistics' }
    ]
  },
  {
    title: 'Statistics',
    path: '/dashboard/statistics/:year/:month',
    component: Components.Statistics.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/statistics', title: 'Statistics' }
    ]
  },
  {
    title: 'Statistics',
    path: '/dashboard/statistics/:comId',
    component: Components.Statistics.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/statistics', title: 'Statistics' }
    ]
  },
  {
    title: 'Statistics',
    path: '/dashboard/statistics/:comId/:year/:month',
    component: Components.Statistics.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/statistics', title: 'Statistics' }
    ]
  },
  {
    title: 'Support',
    path: '/dashboard/support',
    component: Components.Support.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/support', title: 'Support' }
    ]
  },
  {
    title: 'Support',
    path: '/dashboard/support/new',
    component: Components.Support.Create,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/support', title: 'Support' },
      { url: '/dashboard/support/new', title: 'Create New' }
    ]
  },
  {
    title: 'Support',
    path: '/dashboard/support/:id',
    component: Components.Support.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/support', title: 'Support' },
      { url: '/dashboard/support', title: 'View Ticket' }
    ]
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    component: Components.Settings.Main,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/settings', title: 'Settings' }
    ]
  },
  {
    title: 'Motd Editor',
    path: '/dashboard/settings/motd',
    component: Components.Settings.Motd,
    exact: true,
    sitemap: [
      { url: '/dashboard', title: 'Dashboard' },
      { url: '/dashboard/settings', title: 'Settings' }
    ]
  }
]

@inject('Auth', 'User', 'Config')
@observer
export class DashboardNavigator extends React.Component {
  componentWillMount () {
    if (this.props.Auth.token.accessToken) {
      const expDate = new Date(this.props.Auth.token.accessTokenExp)

      Promise.all([
        ...(expDate <= new Date() ? [this.props.Auth.refresh()] : [])
      ])
        .then(() => this.props.User.getUser())
        .then(() => {
          ws.init()
        })
    }

    document.title = `${SUB_NAME} - ${HOME_NAME}`
  }

  render () {
    if (
      !(this.props.staticContext || {}).ssr &&
      !this.props.Auth.token.accessToken
    ) {
      return <Redirect to={`/auth/login`} />
    }

    return (
      <Container fluid>
        <Components.partials.Header />
        <Switch>
          {routeList.map((route, index) => {
            if (route.type === 'redirect') {
              return (
                <Route
                  key={`${route.path}_${route.to}`}
                  exact={route.exact}
                  path={route.path}
                  render={({ match }) => (
                    <Redirect
                      to={Object.keys(match.params).reduce(
                        (_url, key) =>
                          _url.replace(`:${key}`, match.params[key]),
                        route.to
                      )}
                    />
                  )}
                />
              )
            }

            return (
              <Route
                key={`${route.url}_${index}`}
                exact={route.exact}
                path={route.path}
                render={routeProps => [
                  <DashboardNavigation
                    key={0}
                    {...this.props}
                    sitemap={route.sitemap}
                  />,
                  <DashboardContainer
                    key={1}
                    component={route.component}
                    {...route.props || {}}
                    {...routeProps}
                  />
                ]}
              />
            )
          })}
        </Switch>
        <Components.partials.Footer
          onThemeClick={this.props.Config.setTheme}
          theme={this.props.Config.theme}
        />
      </Container>
    )
  }
}

export default DashboardNavigator



// WEBPACK FOOTER //
// ./src/navigators/Dashboard.js